if (window.CURRENT_ENV !== 'development') {
  __webpack_public_path__ = window.CDN_URL
    ? `${window.CDN_URL}/dist/${__webpack_hash__}/`
    : `/dist/${__webpack_hash__}/`
}
